import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import { Button } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { getProductById } from "../../../http/api/ProductAPI";
import OrderingUnitSelect from "./OrderingUnitSelect";
import OriginSelect from "./OriginSelect";
import PackingSelect from "./PackingSelect";
import ProductClassSelect from "./ProductClassSelect";
import RankSelect from "./RankSelect";
import WeightUnitSelect from "./WeightUnitSelect";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規商品明細登録ページ
export default function ProductDetailInfo(props) {
  const { productId, productDetail } = props;

  // 商品
  const [product, setProduct] = useState({});

  // 画面ステータスをcontextから取得
  const { isChanged, setChanged } = useContext(ScreenStatusContext);

  useEffect(() => {
    GetProduct();
  }, [productId]);
  // 商品を取得
  async function GetProduct() {
    let response = await getProductById(productId);
    setProduct(response.listProductInfo[0]);
  }
  // 入力変更時処理
  const onChangeProductDetailInput = (value, prop) => (event) => {
    let valueChanged = productDetail.Value[prop] !== value;
    productDetail.handleChange(value, prop);
    setChanged(isChanged || valueChanged);
  };

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  商品名&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                disabled
                value={product.productName}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  産地&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OriginSelect
                onChange={(e) =>
                  onChangeProductDetailInput(e.target.value, "originId")(e)
                }
                value={productDetail.Value.originId}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  等級&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <RankSelect
                onChange={(e) =>
                  onChangeProductDetailInput(e.target.value, "rankId")(e)
                }
                value={productDetail.Value.rankId}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  階級&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <ProductClassSelect
                onChange={(e) =>
                  onChangeProductDetailInput(e.target.value, "productClassId")(e)
                }
                value={productDetail.Value.productClassId}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  荷姿&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <PackingSelect
                onChange={(e) =>
                  onChangeProductDetailInput(e.target.value, "packingId")(e)
                }
                value={productDetail.Value.packingId}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  重量&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    onChange={(e) =>
                      onChangeProductDetailInput(e.target.value, "weight")(e)
                    }
                    value={productDetail.Value.weight}
                    sx={{ width: 240 }}
                  />
                </Grid>
                <Grid item xs="auto">
                  <WeightUnitSelect
                    onChange={(e) =>
                      onChangeProductDetailInput(e.target.value, "weightUnitId")(e)
                    }
                    value={productDetail.Value.weightUnitId}
                  />
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  入数&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    onChange={(e) =>
                      onChangeProductDetailInput(e.target.value, "quantity")(e)
                    }
                    value={productDetail.Value.quantity}
                    sx={{ width: 400 }}
                  />
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  発注単位&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OrderingUnitSelect
                    onChange={(e) =>
                      onChangeProductDetailInput(
                        e.target.value,
                        "orderingUnitId"
                      )(e)
                    }
                    value={productDetail.Value.orderingUnitId}
                  />
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
